// removed by extract-text-webpack-plugin
module.exports = {"checkboxError":"_2S2qRaq7WUaMu6gMStc6bt"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/utils/checkbox/checkBoxValidation.scss
// module id = 1657
// module chunks = 0